import { ProductionOptimizationDashboard } from '@/components/ProductionOptimizationDashboard';
import { EnhancedProductionOptimizer } from '@/components/EnhancedProductionOptimizer';
import { PageHeader } from '@/components/PageHeader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export default function ProductionOptimization() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Production Optimization"
        description="Monitor and optimize production performance to meet Phase 5 success criteria"
      />
      
      <Tabs defaultValue="optimizer" className="space-y-6">
        <TabsList>
          <TabsTrigger value="optimizer">Smart Optimizer</TabsTrigger>
          <TabsTrigger value="dashboard">Analytics Dashboard</TabsTrigger>
        </TabsList>
        
        <TabsContent value="optimizer">
          <EnhancedProductionOptimizer />
        </TabsContent>
        
        <TabsContent value="dashboard">
          <ProductionOptimizationDashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
}